/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyConfigurationAccountListRequest {
    getFixupPrototypeFunction() { return PolicyConfigurationAccountListRequest.fixupPrototype; }

    static newInstance(model: Partial<PolicyConfigurationAccountListRequest>): PolicyConfigurationAccountListRequest {
        let obj = Object.assign(new PolicyConfigurationAccountListRequest(), model);
        PolicyConfigurationAccountListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyConfigurationAccountListRequest>): PolicyConfigurationAccountListRequest {
        if (!model) return null;
        return PolicyConfigurationAccountListRequest.newInstance(<PolicyConfigurationAccountListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyConfigurationAccountListRequest) {
        if (!obj) return;

        models.PolicyConfigurationAccountListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyConfigurationAccountListRequest): boolean {
        Object.setPrototypeOf(obj, PolicyConfigurationAccountListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * List of service account ids for which policies are configured.
     */
    service_account_ids: Array<string>;

}
